/*
    Cette fonction permet de fusionner les données ayant la même date lors de l'infinite scroll.
    Sans cet utils, lors du scroll, si des données possèdent la même date, alors la date sera affichée plusieurs fois.
*/
export function mergeItemsByDate(items) {
  if (!items || items.length === 0) return [];

  const dateMap = new Map();

  items.forEach((dateGroup) => {
    const dateKey = dateGroup.date;
    if (dateMap.has(dateKey)) {
      const existingGroup = dateMap.get(dateKey);
      existingGroup.items = [...existingGroup.items, ...dateGroup.items];
    } else {
      dateMap.set(dateKey, {
        date: dateGroup.date,
        items: [...dateGroup.items],
      });
    }
  });

  return Array.from(dateMap.values());
}
